import { render } from "./ServiceAlertWidget.vue?vue&type=template&id=1f3c0aff&scoped=true"
import script from "./ServiceAlertWidget.vue?vue&type=script&lang=js"
export * from "./ServiceAlertWidget.vue?vue&type=script&lang=js"

import "./ServiceAlertWidget.vue?vue&type=style&index=0&id=1f3c0aff&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3c0aff"]])

export default __exports__